import { Modal } from 'DesignSystem'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

/**
 * `&&` porque o Modal do DesignSystem repassa a className para o próprio
 * ModalStyled: sem dobrar a especificidade a ordem das folhas decide quem
 * ganha, e o `height: fit-content` dele venceria o flex com altura limitada.
 */
export const ModalS = styled(Modal)`
  && {
    display: flex;
    flex-flow: column nowrap;

    max-height: calc(100vh - 2rem);
    height: auto;
    padding: 0;

    ${breakpoint('mobile', 'tablet')`
      /* o backdrop tem padding de 1rem no eixo vertical — a margem negativa
         cancela para a modal encostar nas bordas da tela */
      width: 100%;
      max-height: none;
      min-height: 100vh;
      margin: -1rem 0;

      border-radius: 0;
    `}
  }
`

export const HeaderS = styled.h4`
  flex: 0 0 auto;
  margin: 0;
  padding: ${({ theme }) => theme.metrics.space5} ${({ theme }) => theme.metrics.space5} ${({ theme }) => theme.metrics.space3};

  text-align: center;
`

export const BodyS = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;

  padding: 0 ${({ theme }) => theme.metrics.space5};

  h5 {
    margin: ${({ theme }) => theme.metrics.space5} 0 ${({ theme }) => theme.metrics.space2};
  }

  p {
    margin: 0 0 ${({ theme }) => theme.metrics.space3};
  }

  ul {
    margin: 0;
    padding-left: ${({ theme }) => theme.metrics.space3};
  }

  li + li {
    margin-top: ${({ theme }) => theme.metrics.space2};
  }

  a {
    color: ${({ theme }) => theme.colors.primary_hover};
    text-decoration: underline;
    word-break: break-all;
  }
`

export const AckS = styled.label`
  width: 100%;
  margin: ${({ theme }) => theme.metrics.space5} 0 0;

  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  gap: ${({ theme }) => theme.metrics.space2};

  cursor: pointer;

  input[type='checkbox'] {
    flex: 0 0 auto;
    width: 1.125rem;
    height: 1.125rem;
    margin-top: 0.125rem;

    accent-color: ${({ theme }) => theme.colors.black};
    cursor: pointer;
  }
`

export const FullTermsS = styled.div`
  margin: ${({ theme }) => theme.metrics.space5} 0;
`

export const FooterS = styled.div`
  flex: 0 0 auto;

  display: flex;
  flex-flow: row nowrap;
  gap: ${({ theme }) => theme.metrics.space3};

  padding: ${({ theme }) => theme.metrics.space3} ${({ theme }) => theme.metrics.space5} ${({ theme }) => theme.metrics.space5};

  border-top: 1px solid ${({ theme }) => theme.colors.gray40};
`
